(() => {
    const id = "xy-";
    const scroller = document.getElementById(id);
    if (!scroller) return;

    const scope = scroller.closest('.xy-section-container') || document;
    const prevBtn = scope.querySelector(`.xy-arrow.prev[data-target="${id}"]`);
    const nextBtn = scope.querySelector(`.xy-arrow.next[data-target="${id}"]`);
    if (!prevBtn && !nextBtn) return;

    const itemsSelector = '.xy-grid-cell';
    let positions = [];

    const computePositions = () => {
        const items = Array.from(scroller.querySelectorAll(itemsSelector));
        positions = items.map(el => el.offsetLeft - scroller.offsetLeft);
    };

    const maxScrollLeft = () => Math.max(0, scroller.scrollWidth - scroller.clientWidth);

    const isAtStart = () => scroller.scrollLeft <= 1;
    const isAtEnd = () => scroller.scrollLeft >= (maxScrollLeft() - 1);

    const currentIndex = () => {
        const x = scroller.scrollLeft;
        let idx = 0, best = Infinity;
        for (let i = 0; i < positions.length; i++) {
            const d = Math.abs(positions[i] - x);
            if (d < best) { best = d; idx = i; }
        }
        return idx;
    };

    const clampScrollLeft = (left) => Math.max(0, Math.min(left, maxScrollLeft()));

    const scrollToIndex = (i) => {
        if (!positions.length) return;
        i = Math.max(0, Math.min(i, positions.length - 1));
        scroller.scrollTo({ left: clampScrollLeft(positions[i]), behavior: 'smooth' });
    };

    const go = (dir) => {
        if (!positions.length) return;

        if (dir > 0 && isAtEnd()) return;
        if (dir < 0 && isAtStart()) return;

        const idx = currentIndex();
        scrollToIndex(idx + dir);
    };

    const updateDisabled = () => {
        prevBtn && (prevBtn.disabled = isAtStart());
        nextBtn && (nextBtn.disabled = isAtEnd());
    };

    prevBtn?.addEventListener('click', () => { go(-1); setTimeout(updateDisabled, 250); }, { passive: true });
    nextBtn?.addEventListener('click', () => { go(1); setTimeout(updateDisabled, 250); }, { passive: true });

    scroller.addEventListener('scroll', () => {
        clearTimeout(scroller.__t);
        scroller.__t = setTimeout(updateDisabled, 80);
    }, { passive: true });

    const ro = new ResizeObserver(() => {
        computePositions();
        updateDisabled();
    });
    ro.observe(scroller);

    // Init
    computePositions();
    updateDisabled();
    window.addEventListener('load', () => { computePositions(); updateDisabled(); });
})();
